import TableSample from './TableSample';

export default TableSample;